import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../Pages/Homepage.css";
import Navbar from "../../commonComponents/Navbar";
import BusinessTravelBanner from "../../Componentsss/BusinessTravel/BusinessTravelBanner/BusinessTravelBanner";
import BusinessTravelContent from "../../Componentsss/BusinessTravel/BusinessTravelContent/BusinessTravelContent";
import BTmidBanner from "../../Componentsss/BusinessTravel/BTmidBanner/BTmidBanner";
import TravelManagement from "../../Componentsss/BusinessTravel/TravelManagement/TravelManagement";
// import ConnectForm from '../../Componentsss/Contactus/ConnectForm/ConnectForm';
import Footer from "../../commonComponents/Footer";
import WhyBBtravel from "../../Componentsss/BusinessTravel/WhyBBtravel/WhyBBtravel";

const BusinessTravel = () => {
  const [bannerLoaded, setBannerLoaded] = useState(false);

  return (
    <>
      {bannerLoaded && <Navbar />}
      <BusinessTravelBanner onLoad={() => setBannerLoaded(true)} />
      {bannerLoaded && (
        <>
          <BusinessTravelContent />
          <BTmidBanner />
          <WhyBBtravel />
          <TravelManagement />
          {/* <ConnectForm /> */}
          <Footer />
        </>
      )}
    </>
  );
};

export default BusinessTravel;
